import React from 'react';
// elements
import Form from '../Common/Form.react';
import TextField from '../Common/TextField';
import { Card, CardText } from 'material-ui/Card';
// business logic
import VendorActions from '../../actions/VendorActionCreator';
import VendorStore from '../../stores/VendorStore';

// constants
// icons

const VendorForm = React.createClass({
    getInitialState: function() {
        return {
            isEdit: (this.props.routeParams.id !== undefined && !!this.props.routeParams.id.match(/\d+/)),
            details: {
                id: '',
                name: '',
                description: ''
            }
        };
    },

    componentDidMount: function() {
        if (this.state.isEdit) {
            VendorStore.addChangeListener(this.onChange);
            VendorActions.getById(this.props.routeParams.id);
        }
    },
    
    componentWillUnmount: function() {
        if (this.state.isEdit) {
            VendorStore.removeChangeListener(this.onChange);
        }
    },
    
    errorMessages: {
        minLength: 'Please use at least 2 letters',
        maxLength: 'Text is too long'
    },
    
    render: function() {
        let formProps = {
            title: (!this.state.isEdit ? 'New' : 'Edit'),
            onSave: this.onSave,
            redirectTo: '/dashboard/vendors',

        };
        return (
            <Form {...formProps}>
                    <Card className="cent-card">
                        <CardText>
                            <TextField
                                name="name"
                                value={this.state.details.name}
                                floatingLabelText="Name"
                                hintText="Name"
                                validations={{minLength:2, maxLength:120}}
                                validationErrors={this.errorMessages}
                                required
                            />
                            <TextField
                                name="description"
                                value={this.state.details.description}
                                floatingLabelText="Description"
                                hintText="Description"
                                multiLine={true}
                                rowsMax={8}
                            />
                        </CardText>
                    </Card>
            </Form>

        );
    },
    
    // prepare data
    
    onChange: function() {
        const details = VendorStore.getById(this.props.routeParams.id);
        if (details !== undefined) {
            this.setState({ details: details });
        }
    },
    
    // handle form
    
    onSave: function(model) {
        if(!this.state.isEdit) {
            return VendorActions.save(model);
        } else {
            return VendorActions.update(this.props.routeParams.id, model);
        }
    },
    
    
});

export default VendorForm;
